import { useMemo } from 'react';

import { useUtilityContext, type UtilityContext } from '@change-corgi/core/react/utilityContext';

import { translateHtml, translatePluralHtml, typedTranslateHtml, typedTranslatePluralHtml } from './html';
import type { TranslateHtmlFn, TranslatePluralHtmlFn, TypedTranslateHtmlFn, TypedTranslatePluralHtmlFn } from './html';

export type I18nUtilities = UtilityContext['i18n'] &
	Readonly<{
		translateHtml: TranslateHtmlFn;
		typedTranslateHtml: TypedTranslateHtmlFn;
		translatePluralHtml: TranslatePluralHtmlFn;
		typedTranslatePluralHtml: TypedTranslatePluralHtmlFn;
	}>;

export function useI18n(): I18nUtilities {
	const { i18n } = useUtilityContext();

	return useMemo(
		() => ({
			...i18n,
			translateHtml: (key, replacements, options) => translateHtml(i18n.translate, key, replacements, options),
			typedTranslateHtml: (key, replacements, options) =>
				typedTranslateHtml(i18n.typedTranslate, key, replacements, options),
			translatePluralHtml: (key, count, replacements, options) =>
				translatePluralHtml(i18n.translatePlural, key, count, replacements, options),
			typedTranslatePluralHtml: (key, count, replacements, options) =>
				typedTranslatePluralHtml(i18n.typedTranslatePlural, key, count, replacements, options),
		}),
		[i18n],
	);
}
